import { ChartsTooltipProps } from '@mui/x-charts/ChartsTooltip';
import React from 'react';

import ChartTooltip from 'components/charts/chart-tooltip';

// No totalLabel: growth values are rates, so a sum across series means nothing. Forward the slot props to keep the chart's trigger.
const BenchmarkChartTooltip = (props: ChartsTooltipProps) => <ChartTooltip {...props} />;

export default BenchmarkChartTooltip;
